import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    themecolor:'1'//默认为1
  },
  mutations:{
    //更新主题颜色
    setThemeColor(state,curcolor){
      this.state.themecolor = curcolor;
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js